import React from "react";
import { Skeleton } from "@mui/material";
import "./FormContentSkeleton.css";

function FormContentSkeleton({ rows = 4 }) {
  return (
    <div className="form-content-skeleton" aria-label="Loading form" role="status">
      <Skeleton className="form-content-skeleton-intro" variant="rounded" />
      {Array.from({ length: rows }, (_, index) => (
        <div className="form-content-skeleton-item" key={index}>
          <Skeleton variant="rounded" className="form-content-skeleton-text" />
          <Skeleton variant="rounded" className="form-content-skeleton-check" />
        </div>
      ))}
      <Skeleton variant="rounded" className="form-content-skeleton-signature" />
    </div>
  );
}

export default FormContentSkeleton;
